import { GenericOrganization } from "../types";

function findOrganizationFromContact<T, K extends keyof T>(contact: T, organizations: GenericOrganization[], field: K) {
  if (!contact) return null;
  const organization = organizations.find((organization) => organization?._id === contact[field]);
  return organization ? organization._id : null;
}

export default findOrganizationFromContact;
